import { render } from "./validateAccount.vue?vue&type=template&id=554c1f06"
import script from "./validateAccount.vue?vue&type=script&lang=js"
export * from "./validateAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__